module.exports = __webpack_public_path__ + "img/faile_icon3.c2c5420a.png";